import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=55f9d4f0&"
var script = {}
import style0 from "./Response.vue?vue&type=style&index=0&id=55f9d4f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports